import React, { createContext, forwardRef, useContext, useImperativeHandle, useMemo, useRef } from 'react';
const CustomFieldReseterContext = /*#__PURE__*/createContext(null);
export const useCustomFieldReseter = () => useContext(CustomFieldReseterContext);
// this is use to reset the dirty = true useCustomField hooks
const CustomFieldReseter = /*#__PURE__*/forwardRef(({
  children
}, ref) => {
  const collections = useRef({});
  useImperativeHandle(ref, () => ({
    trigger: () => {
      Object.keys(collections.current).forEach(name => {
        const callback = collections.current[name];

        if (typeof callback === 'function') {
          callback();
        }
      });
    }
  }), []);
  const value = useMemo(() => ({
    addCallbackReset: (name, callback) => {
      collections.current[name] = callback;
    },
    removeCallbackReset: name => {
      delete collections.current[name];
    }
  }), []);
  return /*#__PURE__*/React.createElement(CustomFieldReseterContext.Provider, {
    value: value
  }, children);
});
export default CustomFieldReseter;